import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Loader2, ChevronLeft, Store, MonitorSmartphone, GraduationCap, ArrowRight, ShoppingBag } from "lucide-react";
import { api } from "../lib/api";

const ORIGEN_META = {
  Marketplace: { Icon: Store, color: "#D97706" },
  Software: { Icon: MonitorSmartphone, color: "#0891B2" },
  Academia: { Icon: GraduationCap, color: "#7E22CE" },
};
const soles = (n) => `S/ ${Number(n || 0).toFixed(2)}`;
const fecha = (iso) => (iso ? new Date(iso).toLocaleDateString("es-PE", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export default function MisPedidosPage() {
  const [data, setData] = useState(undefined);
  const [filtro, setFiltro] = useState("todos");

  useEffect(() => {
    api.get("/cuenta/pedidos").then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);

  const items = (data?.items || []).filter((i) => filtro === "todos" || i.origen === filtro);
  const r = data?.resumen;

  return (
    <div className="px-5 md:px-8 py-8 max-w-4xl" data-testid="mis-pedidos-page">
      <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-slate-800">
        <ChevronLeft size={16} /> Volver al Ecosistema
      </Link>
      <h1 className="mt-4 text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight inline-flex items-center gap-3">
        <Package size={30} style={{ color: "#16A34A" }} /> Mis pedidos
      </h1>
      <p className="mt-2 text-slate-600">Compras, pedidos y solicitudes realizadas en el ecosistema ConstruLink.</p>

      {r && (
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
          {[["Total", r.total], ["Marketplace", r.marketplace], ["Software", r.software], ["Academia", r.academia]].map(([l, v]) => (
            <div key={l} className="bg-white rounded-2xl border border-slate-100 shadow-soft p-4 text-center">
              <p className="text-2xl font-extrabold text-slate-900">{v}</p>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{l}</p>
            </div>
          ))}
        </div>
      )}

      <div className="mt-6 flex flex-wrap gap-2">
        {["todos", "Marketplace", "Software", "Academia"].map((f) => (
          <button key={f} onClick={() => setFiltro(f)} data-testid={`pedidos-filtro-${f}`}
            className={`text-xs font-semibold px-3 py-1.5 rounded-full border transition-colors ${filtro === f ? "bg-slate-900 text-white border-slate-900" : "text-slate-600 border-slate-200 hover:bg-slate-50"}`}>
            {f === "todos" ? "Todos" : f}
          </button>
        ))}
      </div>

      <div className="mt-4 space-y-2">
        {data === undefined && <div className="flex items-center gap-2 text-slate-500 py-16"><Loader2 className="animate-spin" size={16} /> Cargando pedidos…</div>}
        {data === null && <p className="text-sm text-slate-400 py-10">No se pudieron cargar tus pedidos.</p>}
        {data && items.length === 0 && (
          <div className="text-center py-16 bg-white rounded-2xl border border-slate-100" data-testid="pedidos-vacio">
            <ShoppingBag size={40} className="mx-auto text-slate-300" />
            <p className="mt-3 text-slate-500">Aún no tienes pedidos. Explora el Marketplace, Software o Academia.</p>
          </div>
        )}
        {items.map((it, i) => {
          const m = ORIGEN_META[it.origen] || { Icon: Package, color: "#475569" };
          const Icon = m.Icon;
          return (
            <Link to={it.enlace} key={i} data-testid={`pedido-item-${i}`}
              className="flex items-center gap-3 p-4 rounded-2xl border border-slate-100 bg-white hover:border-slate-300 transition-colors">
              <span className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${m.color}15`, color: m.color }}><Icon size={18} /></span>
              <div className="min-w-0 flex-1">
                <p className="font-bold text-slate-900 text-sm truncate">{it.titulo}</p>
                <p className="text-xs text-slate-500">{it.origen} · {it.tipo} · {fecha(it.fecha)}</p>
              </div>
              <span className="text-sm font-bold text-slate-900">{it.precio > 0 ? soles(it.precio) : "Gratis"}</span>
              <ArrowRight size={16} className="text-slate-300 flex-shrink-0" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
